import { render, staticRenderFns } from "./FrequencyChangeDialog.vue?vue&type=template&id=0fbbcc97&scoped=true"
import script from "./FrequencyChangeDialog.vue?vue&type=script&lang=js"
export * from "./FrequencyChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./FrequencyChangeDialog.vue?vue&type=style&index=0&id=0fbbcc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbcc97",
  null
  
)

export default component.exports